import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import { EnumSignType } from '@/libs/twcaHelper';

/**
 * @todo Api 傳入值
 */
export interface FuturesKnowledgePostBackReq {
    data: IData;
    signType: EnumSignType;
    twca_Signature: string;
    twca_PlainText: string;
    esunMCA_Base64DataPlaintext: string;
    esunMCA_Signed: string;
    esunMCA_Seq: string;
}

export interface IData {
    needHelp: boolean;
    futuresKnowledges: Array<string>;
}
/**
 * @todo Api 回傳值
 */
export interface FuturesKnowledgePostBackResp extends GeneralResp {}

/**
 * @todo 期貨交易知識認知確認表
 */
const FuturesKnowledgePostBack = (data: FuturesKnowledgePostBackReq): Promise<FuturesKnowledgePostBackResp> => {
    const url = RouteUrlList.API_FuturesKnowledgePostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<FuturesKnowledgePostBackResp>) => {
        return res.data;
    });
};

export default FuturesKnowledgePostBack;
